export const expenseApiNm = {
  getExpense: "/expense/getExpense",
  insertExpense: "/expense/insertExpense",
  updateExpense: "/expense/updateExpense",
  deleteExpense: "/expense/deleteExpense"
}


export const expenseColNm =  {
  ExpId: "ชื่อค่าใช้จ่าย",
  ExpNm: "ชื่อค่าใช้จ่าย",
  ExpNmEn: "ชื่อค่าใช้จ่าย (Invoice)",
  ExpTypId: "ประเภทค่าใช้จ่าย",
  ExpTypNm: "ประเภทค่าใช้จ่าย",
  VatPrct: "Vat. (%)",
  WhtPrct: "หัก ณ ที่จ่าย (%)",
  UntPr: "ราคา",
  Prty: "Priority",
  IsCost: "รายได้/ต้นทุน",
  IsOwnRcpt: "ประเภทใบเสร็จ",
  Rmk: "หมายเหตุ",
  ModDte: "วันที่แก้ไข",
  ModAcc: "ผู้แก้ไข",
  XpssStkCod: "รหัสบัญชี ขาย (ใบเสร็จลูกค้า)",
  XpssStkCodOR: "รหัสบัญชี ขาย (ใบเสร็จบริษัท)",
  XpssStkCodBuy: "รหัสบัญชี ซื้อ (สำรองจ่าย)",
  XpssStkCodBuyOR: "รหัสบัญชี ซื้อ (ต้นทุน)",
  IsOprShow: "แสดงในค่าใช้จ่ายหน้างาน",
  NotPostGL: "ไม่ลง GL",
  RcptCd: "หมวดใบเสร็จ (AI)",
  IsActv: "สถานะ",
}

// Receipt categories Gemini can return (Util/geminiReadFile.js RCPT_CDS)
export const rcptCdOptions = [
  { id: "PORT", label: "PORT - ค่าผ่านท่าเรือ" },
  { id: "LIFT", label: "LIFT - ค่ายกตู้เปล่า" },
  { id: "GATE", label: "GATE - ค่าผ่านลาน" },
  { id: "TOLL", label: "TOLL - ค่าทางด่วน" },
  { id: "CLEAN", label: "CLEAN - ค่าล้างตู้" },
  { id: "FUEL", label: "FUEL - เติมน้ำมันรถ (ปั๊ม)" },
  { id: "FSC", label: "FSC - ค่าเชื้อเพลิง (ลานตู้)" },
]